import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogTitle, 
  ogDescription, 
  ogType = 'website',
  ogImage = '/logo.png', // Fallback to your logo
  canonical
}) => {
  const siteName = 'TeamBoard PMS';
  const fullTitle = `${title} | ${siteName}`;
  const defaultDescription = 'TeamBoard is an intelligent, secure project management system by Leanport Software. Manage tasks with Gemini AI, secure credentials, and scale with flat-fee pricing.';

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description || defaultDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || description || defaultDescription} />
      <meta name="twitter:image" content={ogImage} />

      {/* Canonical Link */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Security & Ownership Context (Leanport) */}
      <meta name="author" content="Leanport Software Pvt. Ltd." />
    </Helmet>
  );
};

export default SEO;
